import { useEffect } from "react";
import { Play, Pause, Square, SkipBack, Rewind, FastForward } from "lucide-react";
import { timecode } from "@/lib/format";

export const TransportBar = ({ player, extra }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") return;
      if (e.code === "Space") { e.preventDefault(); player.playing ? player.pause() : player.play(); }
      if (e.key === "ArrowLeft") player.seek(player.time - 5);
      if (e.key === "ArrowRight") player.seek(player.time + 5);
      if (e.key.toLowerCase() === "a") player.setAb(player.ab === "A" ? "free" : "A");
      if (e.key.toLowerCase() === "b") player.setAb(player.ab === "B" ? "free" : "B");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [player]);

  const btn = "h-9 w-9 grid place-items-center rounded-sm border border-[#3A4A68] hover:bg-[#1E2738] transition-colors disabled:opacity-30";
  return (
    <div data-testid="persistent-transport-bar" className="sticky bottom-0 z-30 mt-4 panel bg-[#121721]/95 backdrop-blur-md px-4 py-3 flex items-center gap-4 flex-wrap">
      <div className="flex items-center gap-1.5">
        <button data-testid="qc-skip-start-button" className={btn} onClick={() => player.seek(0)} title="Start"><SkipBack size={15} /></button>
        <button data-testid="qc-rewind-button" className={btn} onClick={() => player.seek(player.time - 5)} title="-5 s"><Rewind size={15} /></button>
        <button data-testid="qc-play-pause-button" disabled={!player.ready} onClick={() => (player.playing ? player.pause() : player.play())}
          className="h-9 px-4 rounded-sm bg-[#E11D48] hover:bg-[#be123c] text-white flex items-center gap-2 text-sm font-semibold disabled:opacity-40">
          {player.playing ? <Pause size={15} /> : <Play size={15} />} {player.playing ? "Pause" : "Play"}
        </button>
        <button data-testid="qc-stop-button" className={btn} onClick={player.stop} title="Stop"><Square size={14} /></button>
        <button data-testid="qc-forward-button" className={btn} onClick={() => player.seek(player.time + 5)} title="+5 s"><FastForward size={15} /></button>
      </div>
      <div data-testid="qc-timecode-display" className="timecode text-2xl font-bold tracking-widest text-emerald-400 tabular-nums">{timecode(player.time)}</div>
      <div className="font-mono text-xs text-slate-500">/ {timecode(player.duration)}</div>
      <div className="flex items-center gap-1 ml-2">
        <span className="micro mr-1">A/B</span>
        {[["A", "Original mix"], ["B", "Reconstructed D+M&E"], ["free", "Free (solo/mute)"]].map(([mode, label]) => (
          <button key={mode} data-testid={`qc-ab-${mode.toLowerCase()}-button`} onClick={() => player.setAb(mode)}
            className={`px-3 h-8 rounded-sm border text-xs font-medium transition-colors ${player.ab === mode ? (mode === "A" ? "bg-slate-200 text-black border-slate-200" : mode === "B" ? "bg-emerald-500 text-black border-emerald-500" : "bg-cyan-500/20 text-cyan-200 border-cyan-500") : "border-[#3A4A68] text-slate-300 hover:bg-[#1E2738]"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="hidden xl:block text-[11px] text-slate-500 font-mono">Space play · ←/→ ±5 s · A / B toggle</div>
      <div className="ml-auto flex items-center gap-2">{extra}</div>
    </div>
  );
};
